import axios from "axios";
import _ from "lodash";

const ZIPCODEBASE_API_KEY = "58413200-3624-11f0-8111-8b965f0de093";
const ZIPCODEBASE_URL = "https://app.zipcodebase.com/api/v1/search";

export const resolvers = {
  IND: async (
    pincode: string
  ): Promise<
    { district: string; cityTown: string; state: string } | undefined
  > => {
    try {
      const indiaPostResponse = await axios.get(
        `https://api.postalpincode.in/pincode/${pincode}`
      );

      const postOffice = _.get(indiaPostResponse.data, "0.PostOffice.0");

      if (postOffice) {
        return {
          district: postOffice.District,
          cityTown: postOffice.Name,
          state: postOffice.State,
        };
      }

      throw new Error("Empty India Post response");
    } catch (primaryError) {
      console.warn("India Post API failed, trying Zipcodebase fallback...");

      try {
        const url = `${ZIPCODEBASE_URL}?apikey=${ZIPCODEBASE_API_KEY}&codes=${pincode}`;

        const fallbackResponse = await axios.get(url);
        const results = _.get(fallbackResponse.data, `results.${pincode}`, []);

        const indianResult = results.find((r: any) => r.country_code === "IN");

        if (indianResult) {
          return {
            district: indianResult.province,
            cityTown: indianResult.city,
            state: indianResult.state,
          };
        }
      } catch (fallbackError) {
        console.error("Zipcodebase fallback also failed:", fallbackError);
      }
    }

    return undefined;
  },
};
